import { render, staticRenderFns } from "./CaRd.vue?vue&type=template&id=70037432"
import script from "./CaRd.vue?vue&type=script&lang=js"
export * from "./CaRd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports